export default __webpack_public_path__ + "static/media/creator-image.0760c88c.webp";